import { formatDateTime } from "../../utils/applicationFormatters";
import {
  creditHistoryRowKey,
  formatCreditHistoryScore,
  getHitCodeFromScoreNotes,
  getHitDescriptionFromScoreNotes,
  hitDescriptionIsSqlError,
} from "../../utils/creditReportHelpers";
import styles from "../../styles/applicationDetail.module.css";
import { FraudAlertsTooltip } from "./CreditReportFraudAlerts";
import type { CreditReportHistorySectionProps } from "../../types";

export function CreditReportHistorySection({ tab }: CreditReportHistorySectionProps) {
  const { creditReportHistory } = tab;

  if (creditReportHistory.length === 0) return null;

  return (
    <div className="mt-6">
      <div className={styles.creditReportHistoryPanel} role="alert">
        <h2 className={styles.creditReportHistoryTitle}>Credit report history</h2>
        <table className={`${styles.table} ${styles.creditReportHistoryTable}`} data-testid="application-credit-report-tab-credit-history-table">
          <thead>
            <tr>
              <th scope="col">Hit code</th>
              <th scope="col">Hit description</th>
              <th scope="col">Score</th>
              <th scope="col">Request time</th>
              <th scope="col">Request by</th>
            </tr>
          </thead>
          <tbody>
            {creditReportHistory.map((item, index: number) => {
              const desc = getHitDescriptionFromScoreNotes(item?.score_notes);
              const sql = hitDescriptionIsSqlError(desc);
              const hit = getHitCodeFromScoreNotes(item?.score_notes);
              return (
                <tr key={creditHistoryRowKey(item, index)} data-testid={`application-credit-report-tab-row-${creditHistoryRowKey(item, index)}`}>
                  <td className={styles.creditReportHistoryHitCode}>
                    {hit != null ? hit : "—"}
                  </td>
                  <td className={styles.creditReportHistoryDescCell}>
                    <span className={styles.creditReportHistoryDescInner}>
                      {sql ? (
                        <span>
                          There was an error when processing the data in the database.
                        </span>
                      ) : desc ? (
                        <span
                          className={styles.creditReportHistoryDescHtml}
                          dangerouslySetInnerHTML={{ __html: desc }}
                        />
                      ) : (
                        <span className={styles.creditReportHistoryEmpty}>—</span>
                      )}
                      <FraudAlertsTooltip scoreData={item} />
                    </span>
                  </td>
                  <td className={styles.creditReportHistoryScore}>
                    {formatCreditHistoryScore(item?.score)}
                  </td>
                  <td className={styles.creditReportHistoryTime}>
                    {formatDateTime(item.created_at)}
                  </td>
                  <td>{item.username || "System"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
